module.exports = __webpack_public_path__ + "static/media/icon-visa.fcef0550.png";